import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { firestore } from '../firebase.config';
import { FaTrash, FaDownload, FaBars } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';

const ViewCandidate = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchName, setSearchName] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [searchMobile, setSearchMobile] = useState('');
  const itemsPerPage = 5;

  const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      try {
        const usersCollection = collection(firestore, 'users');
        const usersSnapshot = await getDocs(usersCollection);
        const usersList = usersSnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((user) => user.email !== 'projectour24@gmail.com');
        setUsers(usersList);
        setFilteredUsers(usersList);
        setIsLoading(false);
      } catch (err) {
        console.error('Error fetching users:', err);
        setError('Failed to fetch users. Please try again later.');
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    const filtered = users.filter((user) => {
      const mobile = user.mobile ? String(user.mobile) : '';
      const userName = user.name ? user.name.toLowerCase() : '';
      const userEmail = user.email ? user.email.toLowerCase() : '';

      return (
        userName.includes(searchName.toLowerCase()) &&
        userEmail.includes(searchEmail.toLowerCase()) &&
        mobile.includes(searchMobile)
      );
    });
    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [searchName, searchEmail, searchMobile, users]);

  const handleDelete = async (userId) => {
    if (window.confirm('Are you sure you want to delete this Candidate?')) {
      try {
        const userDocRef = doc(firestore, 'users', userId);
        await deleteDoc(userDocRef);
        setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
        toast.success('Candidate Data successfully deleted!');
      } catch (err) {
        console.error('Error deleting user:', err);
        toast.error('Error deleting user. Please try again.');
      }
    }
  };

  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage) || 1;

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };
  return (
    <div className="lg:flex h-screen overflow-hidden">
           <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

           <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 
          ${isSidebarOpen ? "ml-56 p-2 mr-[-16px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}  
        >
        <h1 className="lg:text-2xl text-lg font-[500] mb-6 p-2">Candidate List</h1>

        <div className="mb-4 lg:flex lg:flex-row flex-col  gap-4 p-2">
          <input
            type="text"
            placeholder="Search by Name"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            className="px-4 py-2 border mb-2 lg:text-[15px] text-[13px]"
          />
          <input
            type="text"
            placeholder="Search by Email"
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
            className="px-4 py-2 border mb-2 lg:text-[15px] text-[13px]"
          />
          <input
            type="text"
            placeholder="Search by Mobile"
            value={searchMobile}
            onChange={(e) => setSearchMobile(e.target.value)}
            className="px-4 py-2  mb-2 border lg:text-[15px] text-[13px]"
          />
        </div>

        {isLoading && (
          <div className="flex justify-center items-center my-4">
            <svg className="animate-spin h-8 w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
            </svg>
            <span className="ml-2 lg:text-lg text-md">Loading candidates...</span>
          </div>
        )}

        {error && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
          >
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">{error}</span>
          </motion.div>
        )}

        {!isLoading && !error && (
          <div className="overflow-x-auto p-2">
            <table className="min-w-full bg-white border border-gray-300 rounded-md shadow-sm text-sm">
              <thead>
                <tr className="bg-gray-100 border-b border-gray-300">
                  <th className="py-2 px-4 text-left">Id</th>
                  <th className="py-2 px-4 text-left">Name</th>
                  <th className="py-2 px-4 text-left">Email</th>
                  <th className="py-2 px-4 text-left">Mobile</th>
                  <th className="py-2 px-4 text-left">Resume</th>
                  <th className="py-2 px-4 text-left">Created At</th>
                  <th className="py-2 px-4 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user) => (
                    <tr key={user.id} className="border-b border-gray-300 hover:bg-gray-50">
                      <td className="py-2 px-4">{user.id}</td>
                      <td className="py-2 px-4">{user.name}</td>
                      <td className="py-2 px-4">{user.email}</td>
                      <td className="py-2 px-4">{user.mobile || 'NA'}</td>
                      <td className="py-2 px-4">
                        <a href={user.resume} target="_blank" rel="noopener noreferrer" className="text-blue-500 text-[13px] hover:underline flex items-center">
                          Download Resume <FaDownload className="ml-1 text-[13px]" />
                        </a>
                      </td>
                      <td className="py-2 px-4">
                        {user.createdAt ? new Date(user.createdAt.seconds * 1000).toLocaleString() : 'N/A'}
                      </td>
                      <td className="py-2 px-4 flex space-x-2">
                        <button className="text-red-500 hover:text-red-700 transition-colors duration-200" onClick={() => handleDelete(user.id)} title="Delete User">
                          <FaTrash size={13} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      No candidates found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination Controls */}
        <div className="lg:flex-row lg:flex flex-col justify-center items-center mt-4 space-x-2 p-2">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className="px-4 py-2 border rounded-lg transition duration-200"
            style={{
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              opacity: currentPage === 1 ? 0.5 : 1,
            }}
          >
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 border rounded-lg transition duration-200 ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-white text-blue-500 hover:bg-blue-100'}`}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className="px-4 py-2 border rounded-lg transition duration-200"
            style={{
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              opacity: currentPage === totalPages ? 0.5 : 1,
            }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCandidate;
